var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Статусы откликов",
      "create-text": "Новый статус",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "RecruitResponseStatusAdd",
      "route-edit": "RecruitResponseStatusEdit",
      "route-view": "RecruitResponseStatusView",
      "route-path": "/recruit_response_statuses",
      "can-edit": _vm.canEditRecruitResponseStatuses()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00806e0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00806e0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/RecruitResponseStatuses/RecruitResponseStatuses.vue
// module id = null
// module chunks = 